/*
 * Note: This file is used to export all organisms components
 * so that we can import all organisms components from a single file
 * instead of importing each component individually
 * e.g. import { Component, componentVariants } from '@/components/ui/organisms';
 * instead of import { Component, componentVariants } from '@/components/ui/organisms/Component';
 */

import {
  CardNewsEventList,
  type TCardNewsEventListProps,
} from "./cards/card-news-event-list/CardNewsEventList"
import { CardPartenaireList } from "./cards/card-partenaire-list/CardPartenaireList"
import { CardListContainer } from "./containers/CardListContainer"
import { HeroSection } from "./hero-section/HeroSection"
import {
  MainNavigationMenu,
  type TNavItem,
} from "./main-navigation-menu/MainNavigationMenu"
import { NavHeader } from "./nav-header/NavHeader"
import { type TNavButtons } from "./navigation/Navigation"

export {
  CardListContainer,
  CardNewsEventList,
  type TCardNewsEventListProps,
  HeroSection,
  CardPartenaireList,
  MainNavigationMenu,
  type TNavItem,
  type TNavButtons,
  NavHeader,
}
